import { render } from "./ConfirmView.vue?vue&type=template&id=c243db6e"
import script from "./ConfirmView.vue?vue&type=script&lang=js"
export * from "./ConfirmView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__